/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mainContent: {
    minHeight: 0,
    flex: 1,
    '& > *': {
      height: '100%'
    }
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: Tokens.spacing['$sp-3']
  },
  topLeftHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-2'],
    textAlign: 'right',
    height: Tokens.spacing['$sp-7-5'],
    color: theme.palette.text.secondary,
    borderBottomColor: theme.palette.divider,
    marginRight: Tokens.spacing['$sp-0-25'],
  },
  topRightHeaderContainer: {
    padding: Tokens.spacing['$sp-2'],
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  exportButton: {
    cursor: 'pointer',
    position: 'relative'
  },
  exportIconFile: {
    lineHeight: 'normal',
    marginLeft: Tokens.spacing['$sp-2'],
    paddingTop: Tokens.spacing['$sp-1'],
  },
  roleActionItems: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  rightContainer: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    overflowY: 'auto',
    height: '100%',
    "&.MuiBox-root": {
      padding: Tokens.spacing['$sp-0']
    }
  },
  containerGid: {
    position: 'relative'
  },
  noClients: {
    marginTop: Tokens.spacing['$sp-3-5'],
    padding: Tokens.spacing['$sp-2']
  },
  listItemPaper: {
    height: '100%',
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    overflowY: 'auto',
    marginRight: Tokens.spacing['$sp-0-25']
  },
  listContainerBorder: {
    
  },
  displayNameHeading: {
    flex: '1'
  },
  plusIcon: {
    paddingTop: Tokens.spacing['$sp-1'],
    cursor: 'pointer'
  },
  textSize: {
    fontWeight: 500,
  },
  app: {
    textAlign: 'center',
    fontSize: Tokens.spacing['$sp-3-5'],
    color: theme.palette.text.secondary,
  },
  roleEditButton: {
    marginLeft: 'auto'
  }
}));

